const GOOGLE_MAPS_SCRIPT_ID = "google-maps-javascript-api";
const GOOGLE_MAPS_CALLBACK_NAME = "__onGoogleMapsLoaded";

let googleMapsPromise = null;

function buildGoogleMapsScriptUrl(apiKey) {
  const params = new URLSearchParams({
    callback: GOOGLE_MAPS_CALLBACK_NAME,
    key: apiKey,
    libraries: "places",
    loading: "async",
    language: "sv",
    region: "SE",
    v: "weekly",
  });

  return `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
}

export function loadGoogleMapsPlaces() {
  if (typeof window === "undefined") {
    return Promise.reject(
      new Error("Google Maps can only be loaded in a browser.")
    );
  }

  if (window.google?.maps?.places) {
    return Promise.resolve(window.google.maps);
  }

  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  if (!apiKey) {
    return Promise.reject(
      new Error("Missing VITE_GOOGLE_MAPS_API_KEY for Google Maps lookup.")
    );
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(GOOGLE_MAPS_SCRIPT_ID);

    const finalizeLoad = () => {
      if (window.google?.maps?.places) {
        resolve(window.google.maps);
        return;
      }

      googleMapsPromise = null;
      reject(new Error("Google Maps Places library is not available."));
    };

    window[GOOGLE_MAPS_CALLBACK_NAME] = finalizeLoad;

    if (existingScript) {
      if (window.google?.maps?.places) {
        finalizeLoad();
        return;
      }

      existingScript.addEventListener("load", finalizeLoad);
      existingScript.addEventListener("error", () => {
        googleMapsPromise = null;
        reject(new Error("Failed to load the Google Maps script."));
      });
      return;
    }

    const script = document.createElement("script");
    script.id = GOOGLE_MAPS_SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.src = buildGoogleMapsScriptUrl(apiKey);
    script.onerror = () => {
      googleMapsPromise = null;
      reject(new Error("Failed to load the Google Maps script."));
    };

    document.head.appendChild(script);
  });

  return googleMapsPromise;
}
